import React from 'react';

const Select = ({
  label,
  error,
  options = [],
  placeholder,
  className = '',
  ...props
}) => {
  return (
    <div className={className}>
      {label && (
        <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
          {label}
          {props.required && <span className="text-red-500 ml-1">*</span>}
        </label>
      )}
      <select
        className={`block w-full rounded-lg border ${error ? 'border-red-300' : 'border-gray-300 dark:border-[#1a3884]/45'
          } px-3 py-2 text-sm bg-white dark:bg-[#002147] text-gray-900 dark:text-gray-100 focus:outline-none focus:ring-2 focus:ring-[#1a3884] dark:focus:ring-[#4f7dff]/50 focus:border-transparent ${props.disabled ? 'bg-gray-100 dark:bg-gray-800 cursor-not-allowed text-gray-400' : ''
          }`}
        {...props}
      >
        <option value="">{placeholder || 'Select an option'}</option>
        {options.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
      {error && <p className="mt-1 text-sm text-red-600">{error}</p>}
    </div>
  );
};

export default Select;
